/**
 * Dealflow entitlement gate (D3).
 *
 * The single, pure decision for "may this investor see the FULL platform
 * dealflow pipeline?". Free investors are gated to a teaser / inbox + upgrade
 * prompt; every paid tier gets the full pipeline. Screens resolve the tier via
 * `useCurrentTier()` (which stays optimistic during the async subscription-load
 * window, per the P0-4 loading-gate invariant) and pass it here so the gate is
 * consistent everywhere and unit-testable in isolation.
 *
 * Historically the dealflow UI hard-coded access (`hasDetailedScoreAccess=true`)
 * and never consulted the entitlement, so free investors saw everything — this
 * function is what closes that hole.
 */

import { investorHasFeature } from './features';
import type { InvestorTier } from './types';

/**
 * Whether an investor tier is entitled to the full platform dealflow pipeline.
 * Mirrors the `platform_dealflow` entitlement (free = false, starter+ = true).
 */
export function investorCanSeePlatformDealflow(tier: InvestorTier): boolean {
  return investorHasFeature(tier, 'platform_dealflow');
}
